module.exports = {
	"id": "TR",
	"name": "Turkey",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.03582,
			"12": 0.00398,
			"13": null,
			"14": null,
			"15": 0.00796,
			"16": 0.00796,
			"17": null,
			"18": 0.00796,
			"19": null,
			"20": null,
			"21": 0.00398,
			"22": 0.17512,
			"23": 0.01194,
			"24": 0.00398,
			"25": 0.01194,
			"26": 0.0597,
			"27": 0.00796,
			"28": 0.00796,
			"29": 0.01194,
			"30": 0.00796,
			"31": 0.0199,
			"32": 0.00796,
			"33": 0.02388,
			"34": 0.0796,
			"35": 0.02786,
			"36": 0.01592,
			"37": 0.01592,
			"38": 0.04776,
			"39": 0.04776,
			"40": 0.0398,
			"41": 0.0199,
			"42": 0.02786,
			"43": 0.1194,
			"44": 0.0995,
			"45": 0.06766,
			"46": 0.13134,
			"47": 0.15124,
			"48": 0.23482,
			"49": 2.2089,
			"50": 0.19502,
			"51": 0.44576,
			"52": 0.61292,
			"53": 19.3229,
			"54": 5.5521,
			"55": 0.02786,
			"56": 0.00796,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.00398,
			"34": 0.00796,
			"35": 0.00796,
			"36": 0.00796,
			"37": 0.00796,
			"38": 0.01194,
			"39": 0.00796,
			"40": 0.00796,
			"41": 0.00796,
			"42": 0.01194,
			"43": 0.0398,
			"44": 0.03184,
			"45": 0.02388,
			"46": 0.03582,
			"47": 0.11542,
			"48": 0.10348,
			"49": 1.22584,
			"50": 0.01194,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.00398
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.01194,
			"37": 0.01592,
			"38": 0.01194,
			"39": 0.00398,
			"40": 0.17114,
			"41": 0.03184,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.01194
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.00398,
			"8": 0.02388,
			"9": 0.0199,
			"10": 0.13532,
			"3.1": null,
			"3.2": null,
			"5.1": 0.01194,
			"6.1": 0.00796,
			"7.1": null,
			"9.1": 0.09552
		},
		"ios_saf": {
			"8": 0,
			"10": 6.61321310575,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.178218440883,
			"8.1-8.4": 0.329251017902,
			"9.0-9.2": 0.1570738801,
			"9.3": 2.39638355537
		},
		"android": {
			"3": 0,
			"4": 0.0984355555556,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0123044444444,
			"4.1": 0.355071111111,
			"4.2-4.3": 0.887677777778,
			"4.4": 2.03550666667,
			"4.4.3-4.4.4": 2.05308444444
		},
		"ie": {
			"6": null,
			"7": 0.00800189473684,
			"8": 0.232054947368,
			"9": 0.224053052632,
			"10": 0.220052105263,
			"11": 2.356558,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0531398559114,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00147610710865
		},
		"edge": {
			"12": 0.05174,
			"13": 0.24278,
			"14": 0.44576
		},
		"ie_mob": {
			"10": 0.106833802817,
			"11": 0.434966197183
		},
		"bb": {
			"7": 0.004515,
			"10": null
		},
		"samsung": {
			"0": 6.67016
		},
		"and_uc": {
			"0": 0.17458
		},
		"op_mini": {
			"0": 0.71594403698
		},
		"and_chr": {
			"0": 38.73124
		},
		"and_ff": {
			"0": 0.01204
		}
	},
	"total": 97.952555
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TR.json
 ** module id = 665
 ** module chunks = 0
 **/